export const tr = {
    abortion: 'Kürtaj',
    'abortion-long-text': 'Kontredikasyonlar var. Doktorunuza danışın. Sağlığınız için zararlı olabilir.',
    acids: 'Asitler, gazlar',
    'ad-image-babyfood': 'Metin-grafik reklamın bebek maması reklamı koşullarına uygun olduğundan emin olun',
    'ad-image-bad-quality': 'Yüklenen görselin yüksek kalitede olduğundan emin olun',
    'ad-image-bad-text': 'Metin-grafik reklamdaki metnin okunabilir olduğundan emin olun',
    'ad-image-distance': 'Metin-grafik reklamın satıcı bilgilerini içerdiğinden emin olun',
    'ad-image-finance':
        'Metin-grafik reklamın, hizmet sağlayıcı hakkında yeterli bilgi ve bilgi kaynağı içerdiğinden emin olun',
    'ad-image-house-cooperative': 'Metin-grafik reklamın kooperatif hakkında bilgi içerdiğinden emin olun',
    'ad-image-interface-element': 'Metin-grafik reklamın, kullanıcı grafik arayüzü öğelerini içermediğinden emin olun',
    'ad-image-lottery': 'Metin-grafik reklamın, promosyon hakkında gerekli bilgileri içerdiğinden emin olun',
    'ad-image-medicine': 'Metin-grafik reklamın gerekli uyarıları içerdiğinden emin olun',
    'ad-image-nasty': 'Metin grafik reklamdaki görseli değiştirin',
    'ad-image-no-border': 'Metin-grafik reklamın net sınırlara sahip olduğundan emin olun',
    'ad-image-no-source': 'Metin-grafik reklamda bilgi kaynağının belirtildiğinden emin olun',
    'ad-image-share-building': 'Kooperatif',
    'ad-image-smi': 'Metin-grafik reklamın, bilgi ürünü kategorisini içerdiğinden emin olun',
    alcohol: 'Alkollü ürünler',
    'alcohol-long-text': 'Aşırı tüketilmesi zararlıdır.',
    'audio-requirements': 'Ses kaydının koşullara uygun olduğundan emin olun',
    'baby_food-long-text': 'Uzmana danışın. {text} aydan itibaren bebek beslenmesi için',
    banks: 'Bankacılık hizmetleri',
    'binary-options': 'İkili işlemler',
    blacklist: 'Sanal kartvizitte belirtilen telefon numarasının doğru olduğundan emin olun',
    bookmaker: 'Bahis faaliyetleri',
    'car-numbers': 'Araç plakalarının kopyaları',
    charity: 'Yardım kuruluşları',
    'contact-info': 'İletişim bilgilerini reklam metninden çıkarın',
    'contact-info-callout': 'Metinde iletişim bilgileri',
    copyright: 'Ödeyen kişinin teminat mektubunu ibraz edin',
    'credit-consumer-cooperative': 'Kredi kooperatifi',
    cryptocurrency: 'Kripto para',
    detective: 'Özel detektiflik faaliyeti',
    'detective-equipment': 'İzleme takip cihazları',
    'dhref-requirements': 'Gösterilen bağlantının Yandex koşullarına uygun olduğundan emin olun',
    dietarysuppl: 'Besin takviyeleri',
    'dietarysuppl-long-text': 'İlaç değildir',
    distance_sales: 'Uzaktan satış',
    drugs: 'Uyuşturan ve reçeteyle satılan ilaçlar',
    'electronic-osago': 'Trafik sigortası e-poliçeler',
    errors: 'Metinde yazım hataları olmadığından ve şablonun doğru kullanıldığından emin olun',
    'errors-callout': 'Metinde yazım hataları var',
    'errors-ql': 'Hızlı bağlantı adlarında yazım hatası olmadığından emin olun',
    'errors-vcard':
        'Reklamı yapılan ürün veya hizmetin sanal kartvizitindeki ayrıntılı açıklamada yazım hatası olmadığından emin olun',
    explosions: 'Piroteknik',
    'false-info': 'Karşılaştırma ve üstünlük sıfatlarını reklam metninden çıkarın',
    'false-info-callout': 'False information in text',
    'false-info-vcard': 'Karşılaştırma ve üstünlük sıfatlarını sanal kartvizitten çıkarın',
    'foreign-trade': 'Dış ticaret analizi',
    forex: 'Forex bayi',
    'forex-broker': 'Forex acente',
    gamble: 'Şans oyunları',
    'html5-babyfood': 'Bebek maması',
    'html5-bad-quality': 'Düşük kalite',
    'html5-bad-text': 'Okunaksız metin',
    'html5-finance': 'Finans',
    'html5-funds': 'Vakıflar',
    'html5-house-cooperative': 'Kooperatif',
    'html5-hrefs-errors': "Banner'daki bağlantının doğru belirtildiğinden emin olun",
    'html5-illness': 'Hastalık',
    'html5-interface-element': 'Arayüz öğeleri',
    'html5-lottery': 'Çekiliş ve promosyon',
    'html5-medicine': 'Sağlık hizmetleri',
    'html5-nasty': 'Uygunsuz görsel',
    'html5-no-border': 'Sınır yok',
    'html5-no-source': 'Kaynak yok',
    'html5-russian-law': 'Rusya yasalarına göre',
    'html5-securities': 'Kıymetli evrak',
    'html5-share-building': 'Kooperatif',
    'html5-smi': 'Çocuk güvenliği',
    'html5-spam': 'NDA. Madde 15',
    'illegal-diet': 'Tedavi amaçlı besin takviyeleri',
    insurance: 'Sigorta hizmetleri',
    'invalid-contacts': 'İletişim bilgilerinin sanal kartvizitte doğru belirtildiğinden emin olun',
    'invalid-url': 'Siteye erişimi kontrol edin',
    'invalid-url-ql': 'Hızlı bağlantıların yönlendirdiği sayfaların geçerli olup olmadığından emin olun',
    'irrelevant-image': 'Görselin reklam konusuna uygun olduğundan emin olun',
    'irrelevant-keywords': 'Anahtar sözcük grupları ekleyin veya düzenleyin',
    'irrelevant-mobile-content':
        'Reklam metnindeki veya konusundaki uygulama açıklaması uygulama mağazasındaki açıklamayla uyumlu değil.',
    'irrelevant-site-link-description': 'Hızlı bağlantının açıklaması reklam metnine uygun değil.',
    jewelry: 'Kuyumcu',
    'kazakh-law': 'Ürün ve hizmetlerinizin reklamına Kazakistan Cumhuriyeti yasalarınca izin verildiğinden emin olun',
    law: 'Hukuki hizmetler',
    'license-required': 'Reklamı yapılan ürün/hizmet için onay belgeleri ibraz edin',
    'license-required-dhref': 'Reklamı yapılan ürün/hizmet için onay belgeleri ibraz edin',
    'license-required-ql': 'Reklamı yapılan ürünü (işi/hizmeti) doğrulayan belgeleri ibraz edin',
    'license-required-vcard': 'Reklamı yapılan ürünü veya hizmeti doğrulayan belgeleri ibraz edin',
    loan: 'Krediler',
    lottery: 'Çekiliş ve promosyon',
    magic: 'Ezoterizm ve sihir',
    'maternity-capital': 'Annelik fonu için kredilendirme',
    'med-equipment': 'Medikal ürünler',
    'med-services': 'Sağlık hizmetleri',
    'med_equipment-long-text': 'Kontrendikasyonlar mevcut. Doktorunuza danışın',
    'med_services-long-text': 'Kontrendikasyonlar mevcut. Doktorunuza danışın',
    mediation: 'Arabuluculuk hizmetleri',
    'medicine-long-text': 'Kontrendikasyonlar mevcut. Doktorunuza danışın',
    mfi: 'Mikrofinans kurumları',
    'news-requirements': 'Reklam metninde bilgi kaynağına atıfta bulunulduğundan emin olun',
    'not-medicine': 'Tıbbi kitaplar, videolar, siteler',
    notary: 'Noter hizmetleri ',
    optics: 'Optik',
    'other-reasons': 'Diğer nedenler',
    pawnshop: 'Rehincilik',
    payment: 'Ödeme sistemleri ve para transferi',
    pharmacy: 'Eczaneler ve ilaçlar',
    'pharmacy-long-text': 'Kontrendikasyonlar mevcut. Doktorunuza danışın',
    'phone-do-not-answer': 'Sanal kartvizitte telefon numarasının çalıştığından emin olun',
    politics: "Siyasi reklamlar Yandex.Direct'te yayınlanamaz",
    'poor-image': 'Arayüze yüksek çözünürlüklü görsel yükleyin',
    'popular-medicine': 'Alternatif tıp, şifacı',
    'project_declaration-long-text': 'Reklamı yapılan sitede proje bildirimi',
    pseudoweapon: 'Silahlar ve benzer ürünler',
    'pseudoweapon-long-text': 'Yapısal olarak silaha benzeyen ürünler',
    psychology: 'Psikoloji',
    'ql-requirements': 'Hızlı bağlantıların yönlendirdiği sayfaların Yandex koşullarına uygun olduğundan emin olun',
    realtor: 'Emlak',
    'russian-law': 'Ürün veya hizmet reklamınızın mevcut yasalara aykırı olmadığından emin olun',
    'russian-law-callout': 'Ürün veya hizmet reklamınızın mevcut yasalara aykırı olmadığından emin olun',
    'russian-law-dhref': 'Reklam mevcut yasalara aykırı',
    'russian-law-image': 'Görselin mevcut yasalara aykırı olmadığından emin olun',
    'russian-law-ql': 'Hızlı bağlantı adlarının mevcut yasalara aykırı olmadığından emin olun',
    'russian-law-vcard':
        'Ürünün (hizmetin) sanal kartvizitteki ayrıntılı açıklamasının mevcut yasalara aykırı olmadığından emin olun',
    'site-requirements': "Sitenin Yandex'in tüm koşullarına uygun olduğundan emin olun",
    spam: "Reklam materyalleri Yandex.Direct'te yayınlanamaz",
    'sports-nutrition': 'Besin takviyeleri',
    study: 'Yurtdışında eğitim ve çalışma',
    tattoo: 'Dövme ve piercing',
    'tech-inspection': 'Teknik bakım',
    telemed: 'Çevrimiçi tıbbi hizmetler',
    tm: 'Orijinal garanti mektubunu ibraz edin',
    'tm-dhref': 'Orijinal garanti mektubunu ibraz edin',
    tobacco: 'Tütün ürünleri ve aksesuarları',
    transport: 'Yolcu taşıma',
    'transport-adv': 'Toplu taşıma araçlarında reklam',
    'turbolanding-requirements': 'Turbo sayfada aranan koşullar',
    'turbolanding-requirements-slink': 'Turbo sayfada aranan koşullar',
    'url-to-other-domain': 'Hızlı bağlantıların adreslerini kontrol edin',
    veterinary: 'Veteriner',
    'video-babyfood': 'Videonun bebek maması reklam koşullarına uygun olduğundan emin olun',
    'video-distance-sales': 'Videonun satıcı hakkında bilgi içerdiğinden emin olun',
    'video-finance': 'Videonun hizmet sağlayıcısı hakkında yeterli bilgi içerdiğinden emin olun',
    'video-house-cooperative': 'Videonun vadeli kooperatif evleri hakkında bilgi içerdiğinden emin olun',
    'video-lottery': 'Videonun etkinlik hakkında yeterli bilgi içerdiğinden emin olun',
    'video-medicine': 'Videonun gerekli uyarıyı içerdiğinden emin olun',
    'video-requirements': 'Videonun koşullara uygun olduğundan emin olun',
    'video-share-building': 'Videonun kooperatif hakkında bilgi içerdiğinden emin olun',
    'video-smi': 'Videonun yaş kategorisi içerdiğinden emin olun',
    weapons: 'Silah',
    'yandex-policy': "Reklam materyallerinin, Yandex Reklam Politikası'na uygun olduğundan emin olun",
    'yandex-policy-auto': 'Ürün/hizmet reklamı yasak',
    'yandex-policy-callout': 'Yandex politikasına göre',
    'yandex-policy-image': 'Görselin Yandex reklam politikasına uygun olduğundan emin olun',
    'yandex-policy-vcard':
        "Reklamı yapılan objenin (ürünün veya hizmetin) sanal kartvizitteki ayrıntılı açıklamasının Yandex'in reklam politikasına uygun olduğundan emin olun"
};
